import { Component, OnInit } from '@angular/core';

import { ResumoBancario } from '@app/models/util/resumo-bancario';
import { MovimentacaoService } from '@app/services/movimentacao.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-financeiro-resumo',
  templateUrl: 'resumo-financeiro.component.html',
  styleUrls: ['./resumo-financeiro.component.scss'],
})
export class ResumoFinanceiroComponent implements OnInit {

  // cdsMask: CDSMask = new CDSMask();

  // pagar/receber
  // lstPagar: PagarPesquisa[] = [];
  // lstReceber: ReceberPesquisa[] = [];
  // lstResumoBanco: ResumoFinanceiroBanco[] = [];
  // paginacaoPagar: Paginacao = new Paginacao();
  //  paginacaoReceber: Paginacao = new Paginacao();
  // pesquisa = new PesquisaRelatorio();

  // caixa
  // caixaAbertura: CaixaAbertura = new CaixaAbertura();
  // prazoTotalEntrada: number = 0;
  // prazoTotalSaida: number = 0;
  // prazoTotal: number = 0;

  // aVistaTotalEntrada: number = 0;
  // aVistaTotalSaida: number = 0;
  // aVistaTotal: number = 0;

  // lstAVista: Array<FpValor>;
  // lstAPrazo: Array<FpValor>;

  // lstUnidades: Unidade[];
  // acessoAOutrasUnidades: boolean = true;

  // resumoCaixa: ResumoDeCaixa = new ResumoDeCaixa;
  rel: any;
  pesquisando: boolean;

  unidadeId = 0;

  constructor(
    private movimentacaoService: MovimentacaoService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit() {
    // this.unidadeService.obterListaUnidade(true).subscribe((data) => {
    //   this.lstUnidades = data;
    //   if (this.lstUnidades != null && this.lstUnidades.length > 0)
    //   {
    //     this.acessoAOutrasUnidades = true;
    //   }
    // });
    this.pesquisando = true;
    this.movimentacaoService.obterResumoFinanceiro().toPromise()
      .then(
        data => {
          this.rel = data;
          this.pesquisando = false;
        },
        () => this.pesquisando = false
      );
  }

  redirect(contaId: number) {
    this.router.navigate(['/financeiro/lancamento', contaId]);
  }
}
